<!--The content below is only a placeholder and can be replaced.-->
<!-- <fieldset class="fieldset fieldset-select-date">
  <legend id="legend-select-date" class="fieldset-label">Date label</legend>

  <div class="form-group">
    <div class="form-field">
      <label for="select-id-1" class="form-label access">Day</label>

      <div class="form-field-select">
        <select class="form-control" id="select-id-1" aria-invalid="false" aria-labelledby="legend-select-date">
          <option>Day</option>
          <option>01</option>
          <option>...</option>
          <option>31</option>
        </select>

        <i class="icon icon-chevron-down" aria-hidden="true"></i>
      </div>
    </div>

    <div class="form-field">
      <label for="select-id-2" class="form-label access">Month</label>

      <div class="form-field-select">
        <select class="form-control" id="select-id-2" aria-invalid="false" aria-labelledby="legend-select-date">
          <option>Month</option>
          <option>January</option>
          <option>...</option>
          <option>December</option>
        </select>

        <i class="icon icon-chevron-down" aria-hidden="true"></i>
      </div>
    </div>

    <div class="form-field">
      <label for="select-id-3" class="form-label access">Year</label>

      <div class="form-field-select">
        <select class="form-control" id="select-id-3" aria-invalid="false" aria-labelledby="legend-select-date">
          <option>Year</option>
          <option>1918</option>
          <option>...</option>
          <option>2018</option>
        </select>

        <i class="icon icon-chevron-down" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</fieldset>
<app-text-input></app-text-input>

<app-accordion></app-accordion>

<label class="switch">
  <input type="checkbox" class="switch-input">
  <span class="access">Toggle label</span>
  <span class="switch-focus" aria-hidden="true"></span>
  <span class="switch-handle" aria-hidden="true"></span>
  <span class="switch-toggle switch-toggle-on" aria-hidden="true">Yes</span>
  <span class="switch-toggle switch-toggle-off" aria-hidden="true">No</span>
</label> -->

<!-- <app-dropdown></app-dropdown> -->

<div  class="test wd-100">
<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<app-session-timeout *ngIf="displayFlag" (continueWithMySession)="extendSessionHandler()" (sessionLogout)="expireSessionHandler()" [userDetails]="loginDetails"></app-session-timeout>
<app-modal *ngIf="isLocked" [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
      (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
    </app-modal>
</div>

<!--<div *ngIf=unSupportedBrowser >
  <div class="position-fixed" *ngIf="cmsDataunsupportedResolution">
    <div class="wrapper card-background-unsupport">
      <div class="Oval">
        <img [id]="img-unsupported" class="width-120" alt="downLoad" src="./assets/images/problem.PNG">
      </div>
      <div>
        <h1 class="margin-top-60" [innerHTML]="cmsDataunsupportedResolution['header']">
        </h1>
       
      </div>
      
       
  
      <div class="content-wrapper margin-top-60">
        <p  class="content-top margin-both" id="unsupported-introduction"
        [innerHTML]="cmsDataunsupportedResolution['Detail']">
        </p>
      </div> 
  
     
    </div>
  </div>
</div>-->
<!-- commented for mobile development -->

<!-- <div class="modal unSupportedmodal" id="unSupportedmodal" *ngIf="unSupportedBrowser">
  <div class="modal-content unSupportedmodal-content">
    <img src="./assets/images/problem.PNG" alt="unSupportedBrowser">
    <h1 class="margin-top-60" [innerHTML]="cmsDataunsupportedResolution['header']">
    </h1>
    <p  class="content-top margin-both" id="unsupported-introduction"
    [innerHTML]="cmsDataunsupportedResolution['Detail']">
    </p>
  </div>
</div> -->